import { cn } from '@crehana/compass.ui/utils';

import type { TBreakpoint, TGetWidgetsQuerySpec } from './types';

const GRID_CLASSES_BY_BREAKPOINT: Record<
  TBreakpoint,
  Record<number, string>
> = {
  lg: {
    1: 'lg:tw-col-span-1',
    2: 'lg:tw-col-span-2',
    3: 'lg:tw-col-span-3',
    4: 'lg:tw-col-span-4',
    5: 'lg:tw-col-span-5',
    6: 'lg:tw-col-span-6',
    7: 'lg:tw-col-span-7',
    8: 'lg:tw-col-span-8',
    9: 'lg:tw-col-span-9',
    10: 'lg:tw-col-span-10',
    11: 'lg:tw-col-span-11',
    12: 'lg:tw-col-span-12',
  },
  md: {
    1: 'md:tw-col-span-1',
    2: 'md:tw-col-span-2',
    3: 'md:tw-col-span-3',
    4: 'md:tw-col-span-4',
    5: 'md:tw-col-span-5',
    6: 'md:tw-col-span-6',
    7: 'md:tw-col-span-7',
    8: 'md:tw-col-span-8',
    9: 'md:tw-col-span-9',
    10: 'md:tw-col-span-10',
    11: 'md:tw-col-span-11',
    12: 'md:tw-col-span-12',
  },
  sm: {
    1: 'sm:tw-col-span-1',
    2: 'sm:tw-col-span-2',
    3: 'sm:tw-col-span-3',
    4: 'sm:tw-col-span-4',
    5: 'sm:tw-col-span-5',
    6: 'sm:tw-col-span-6',
    7: 'sm:tw-col-span-7',
    8: 'sm:tw-col-span-8',
    9: 'sm:tw-col-span-9',
    10: 'sm:tw-col-span-10',
    11: 'sm:tw-col-span-11',
    12: 'sm:tw-col-span-12',
  },
  xs: {
    1: 'tw-col-span-1',
    2: 'tw-col-span-2',
    3: 'tw-col-span-3',
    4: 'tw-col-span-4',
    5: 'tw-col-span-5',
    6: 'tw-col-span-6',
    7: 'tw-col-span-7',
    8: 'tw-col-span-8',
    9: 'tw-col-span-9',
    10: 'tw-col-span-10',
    11: 'tw-col-span-11',
    12: 'tw-col-span-12',
  },
};

function getGridBySpan(span: number, breakpoint: TBreakpoint) {
  return GRID_CLASSES_BY_BREAKPOINT[breakpoint]?.[span] || '';
}

export function transformSpanToClassname(span: TGetWidgetsQuerySpec['span']) {
  // Check if all breakpoints have the same value
  const allEqual = span.sm === span.md && span.md === span.lg;
  // Check if md and lg are equal
  const mdLgEqual = span.md === span.lg;

  let className;
  if (allEqual) {
    // If all breakpoints are equal, only use sm (which will apply to all larger breakpoints)
    className = cn(getGridBySpan(12, 'xs'), getGridBySpan(span.sm, 'sm'));
  } else if (mdLgEqual) {
    // If md and lg are equal, only use xs and sm, md (lg will inherit from md)
    className = cn(
      getGridBySpan(12, 'xs'),
      getGridBySpan(span.sm, 'sm'),
      getGridBySpan(span.md, 'md'),
    );
  } else {
    // Otherwise use all breakpoints
    className = cn(
      getGridBySpan(12, 'xs'),
      getGridBySpan(span.sm, 'sm'),
      getGridBySpan(span.md, 'md'),
      getGridBySpan(span.lg, 'lg'),
    );
  }

  return className;
}
